export default __webpack_public_path__ + "static/media/Trillium-3840px-1440px.jpg.03d17a76.webp";